import { render } from "./EditChecklistUser.vue?vue&type=template&id=56d9dad0"
import script from "./EditChecklistUser.vue?vue&type=script&lang=js"
export * from "./EditChecklistUser.vue?vue&type=script&lang=js"
script.render = render

export default script